import { InjectionToken } from "@angular/core";

export const CLOUD_FUNCTIONS_URL = new InjectionToken<string>("CLOUD_FUNCTIONS_URL")